import type { Artboard } from '../hooks/useCanvasTransform';
import type { CanvasState } from '../hooks/useCanvasTransform';
import { getViewportWorld, intersectsRect } from '../utils/viewport';

export function renderArtboards(
  ctx: CanvasRenderingContext2D,
  state: CanvasState,
  artboards: Artboard[],
  selectedArtboardId?: string | null
) {
  const { viewLeft, viewTop, viewRight, viewBottom } = getViewportWorld(state, ctx.canvas as HTMLCanvasElement);

  for (const ab of artboards) {
    if (!intersectsRect(ab.x, ab.y, ab.width, ab.height, viewLeft, viewTop, viewRight, viewBottom)) continue;
    ctx.fillStyle = ab.color;
    ctx.fillRect(ab.x, ab.y, ab.width, ab.height);
    
    // 선택된 아트보드는 파란색 테두리, 아니면 회색 테두리
    const isSelected = selectedArtboardId === ab.id;
    ctx.strokeStyle = isSelected ? '#007bff' : '#ddd';
    ctx.lineWidth = (isSelected ? 2 : 1) / state.scale;
    ctx.strokeRect(ab.x, ab.y, ab.width, ab.height);
    
    // 아트보드 이름 표시 (좌측 상단 바깥쪽)
    const textY = ab.y - 4 / state.scale;
    const textX = ab.x;
    const fontSize = 9 / state.scale; // 75% 크기 (원본 12의 75%)
    
    // 텍스트가 뷰포트에 보이는지 확인
    if (textY >= viewTop - fontSize && textY <= viewBottom) {
      ctx.save();
      ctx.font = `${fontSize}px sans-serif`;
      ctx.textBaseline = 'bottom';
      ctx.textAlign = 'left';
      
      // 텍스트 배경 (반투명 흰색)
      const textMetrics = ctx.measureText(ab.name);
      const textWidth = textMetrics.width;
      const textHeight = fontSize;
      const padding = 4 / state.scale;
      
      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
      ctx.fillRect(
        textX - padding,
        textY - textHeight - padding,
        textWidth + padding * 2,
        textHeight + padding * 2
      );
      
      // 텍스트 그리기
      ctx.fillStyle = '#333';
      ctx.fillText(ab.name, textX, textY);
      ctx.restore();
    }
  }
}


